import { Row } from "reactstrap";
import DashboardGroup, { DashboardGroupProps } from "./DashboardGroup";
import { hasPermission, permissions, hasRole, roles, IsCauwUser } from "../../utility/helpers/claimHelper";

const groups: DashboardGroupProps[] = [
    {
        title: "System Admin",
        isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
        items: [
            {
                title: "Roles",
                subtitle: "Manage Roles",
                href: "/settings-page/role",
                isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
            },
            {
                title: "Claim",
                subtitle: "Manage Claims",
                href: "/settings-page/claim",
                isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
            },
            {
                title: "Settings",
                subtitle: "Manage Settings",
                href: "/settings-page/settings",
                isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
            },
            {
                title: "Lookup Types",
                subtitle: "Manage Lookup Types",
                href: "/settings-page/lookup/lookup-type",
                isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
            },
        ],
    },
    {
        title: "Admin",
        isDisplayed: hasPermission([permissions.ADMIN_USER, roles.SYSTEM_ADMIN, permissions.MANAGE_AGENCIES,]),
        items: [
            {
                title: "Users",
                subtitle: "Manage Users",
                href: "/settings-page/users",
                isDisplayed: hasPermission([permissions.ADMIN_USER, roles.SYSTEM_ADMIN,]),
            },
            {
                title: "Agencies",
                subtitle: "Manage Agencies",
                href: "/settings-page/agency",
                isDisplayed: hasPermission([permissions.MANAGE_AGENCIES,]),
            },
            {
                title: "Lookup Group",
                subtitle: "Manage Lookup Groups",
                href: "/settings-page/lookup/lookup-group",
                isDisplayed: false,
            },
        ],
    },
    {
        title: "Options",
        isDisplayed: IsCauwUser() || hasPermission([roles.SYSTEM_ADMIN,]),
        items: [
            {
                title: "Gift Investment",
                subtitle: "Manage GiftInvestment",
                href: "/settings-page/gift-investment",
                isDisplayed: IsCauwUser() || hasPermission([roles.SYSTEM_ADMIN,]),
            },
        ],
    },
    {
        title: "Geography",
        isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
        items: [
            {
                title: "County",
                subtitle: "Manage Counties/Parishes",
                href: "/settings-page/county",
                isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
            },
            //{
            //    title: "States",
            //    subtitle: "Manage States",
            //    href: "/settings-page/states",
            //    isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
            //},
        ],
    },
    //{ // hidden per request of Charles Hooker
    //    title: "Templates",
    //    isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
    //    items: [
    //        {
    //            title: "Email",
    //            subtitle: "Manage Email Templates",
    //            href: "/settings-page/email-template",
    //            isDisplayed: hasRole([roles.SYSTEM_ADMIN]),
    //        },
    //    ],
    //},
];

const SettingsDashboard = () => {
    return (
        <div style={{ height: "auto" }}>
            <Row>
                {groups.filter(function (x) { return x.isDisplayed || x.isDisplayed === undefined }).map((item: DashboardGroupProps, index: number) => (
                    <div key={index}>
                        <DashboardGroup
                            title={item.title}
                            items={item.items}
                            isDisplayed={item.isDisplayed}
                        />
                    </div>
                ))}
            </Row>
        </div>
    );
};

export default SettingsDashboard;
